module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e8b628b89467100b7b47fdf1f2fd70dc.png";